import { useMutation } from '@gogame/query';

import { editConversion } from 'scenes/Integrations/sources/conversions/conversions';

import { updateConversion } from '../queryKeyFactory';
import { errorMessageGetter } from './errorMessageGetter';

export const useUpdateConversion = () => {
  const updateMutation = useMutation(updateConversion(), editConversion, {
    refresh: true,
    successMessage: () => 'Integration Updated',
    errorMessage: errorMessageGetter,
  });
  return [updateMutation.mutateAsync, updateMutation];
};
